import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LoginPage, VerifyLoginPage } from "./modules/sbo-login";
import { SboPage, SboUploadPage, HealthCheckPage, PersonalHealthCheckPage } from "./modules/sbo";
import { Header, PrivateRoute, NotFoundPage } from "./modules/common";
import { Provider } from "react-redux";
import store, { persistor } from "./modules/base/redux/store";
import './App.css';

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="*" element={<NotFoundPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/upload" element={<SboUploadPage />} />
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<SboPage />} />
              <Route path="/health-check" element={<HealthCheckPage />} />
              <Route path="/health-check/personal/:health_check_id" element={<PersonalHealthCheckPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
